import * as JSLZString from "lz-string";

export default class Compressor {
  static compress<T>(data: T): string {
    const jsonString = JSON.stringify(data);
    return JSLZString.compressToEncodedURIComponent(jsonString);
  }

  static decompress<T>(compressed: string): T | null {
    const decompressed =
      JSLZString.decompressFromEncodedURIComponent(compressed);
    if (!decompressed) {
      return null;
    }
    return JSON.parse(decompressed);
  }
}
